import axios from 'axios';
import { StatusCodes } from 'http-status-codes';

import { logout } from '@features/auth/slices/auth-slice';
import store from '@app/store';

const BASE_URL = import.meta.env.VITE_API_URL;

const api = axios.create({
  baseURL: BASE_URL,
  timeout: 25000,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    const isUnauthorized = error.response?.status === StatusCodes.UNAUTHORIZED;

    if (isUnauthorized && error.response?.data?.message === 'Unauthorized') {
      store.dispatch(logout());
      if (window.location.pathname !== '/login')
        window.location.href = '/login';
    }

    return Promise.reject(error);
  },
);

api.interceptors.request.use(function (config) {
  const access_token = store.getState().auth.userToken;
  config.headers.Authorization = `Bearer ${access_token}`;
  config.headers['user-ip'] = store.getState().userIp.value;
  return config;
});

export { api };
